import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';

const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 16
};

const thumb = {
  display: 'inline-flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: 'border-box'
};

const thumbInner = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden'
};

const img = {
  display: 'block',
  width: 'auto',
  height: '100%'
};

const FileUploader = ({ onFilesUploaded, onImageSelected }) => {
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);
  const [backgroundImage, setBackgroundImage] = useState(null);
  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    onDrop: acceptedFiles => {
      const filesWithPreview = acceptedFiles.map(file =>
        Object.assign(file, {
          preview: URL.createObjectURL(file)
        })
      );
      setFiles(filesWithPreview);
      onFilesUploaded(filesWithPreview);
      setBackgroundImage(filesWithPreview[0]); // Set the first uploaded file as the background image
    }
  });

  const thumbs = files.map(file => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <img
          src={file.preview}
          style={img}
          onLoad={() => {
            URL.revokeObjectURL(file.preview);
          }}
          alt={file.name}
        />
      </div>
    </div>
  ));

  const handleBackgroundImageRemove = () => {
    setBackgroundImage(null);
  };


  useEffect(() => {
    return () => files.forEach(file => URL.revokeObjectURL(file.preview));
  }, [files]);

  return (
    <section className="container">
      <div {...getRootProps({ className: 'dropzone' })} style={{
        border: '2px dashed #6750A4',
        borderRadius: '8px',
        padding: '20px',
        textAlign: 'center',
        cursor: 'pointer',
        backgroundColor: '#f9f7fc'
      }}>
        <input {...getInputProps()} />
        <div className="image-container" style={{ color: '#6750A4' }}>
          <p style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: '500' }}>
            {t('UploadCoverImage')}
          </p>
          <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
            {t('DragDropImage')}
          </p>
          <p style={{ margin: '8px 0 0 0', fontSize: '12px', color: '#999' }}>
            {t('ThumbnailDescription')}
          </p>
        </div>
      </div>
      <aside style={thumbsContainer}></aside>
    </section>
  );
};

export default FileUploader;
